import React, { useEffect, useState } from "react";
import PrivateRoute from "./route/PrivateRoute";
import Layout from "./layout/Index";

import Error404Classic from "./pages/error/404-classic";
import Error404Modern from "./pages/error/404-modern";
import Error504Modern from "./pages/error/504-modern";
import Error504Classic from "./pages/error/504-classic";

import Faq from "./pages/others/Faq";
import Terms from "./pages/others/Terms";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";

import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthPaths, RedirectAs404 } from "./utils";
import CreatePassword from "./pages/auth/CreatePassword";
import ConfirmationPage from "./pages/auth/Confirmation";
import ResetPassword from "./pages/auth/ResetPassword";
import { Storage } from "./services/storage/storage";
import { useDispatch } from "react-redux";
import { loadCureentUser } from "./store/authSlice";
import { useSelector } from "react-redux";
import { LoadingComponent } from "./components/Component";

const App = () => {
  const location = useLocation();
  const data = useSelector((state) => state.auth);
  let user = Storage.getLoggedInUser();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setLoading(true);
      dispatch(loadCureentUser());
      // dispatch(loadFetchMasterList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data?.loading === false) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
    {!loading ? (
      <Routes>
        {user && AuthPaths.some((item) => item === location.pathname) && (
          <Route path="*" element={<Navigate to={`${process.env.PUBLIC_URL}`} replace />} />
        )}

        {user === undefined && !AuthPaths.some((item) => item === location.pathname) && (
          <Route path="*" element={<Navigate to={`${process.env.PUBLIC_URL}/auth-login`} replace />} />
        )}

        {/* Auth Pages */}
        <Route path={`${process.env.PUBLIC_URL}/auth-reset`} element={<ForgotPassword />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/auth-register`} element={<Register />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/auth-login`} element={<Login />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/auth-create-password`} element={<CreatePassword />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/confirmation`} element={<ConfirmationPage />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/reset-password`} element={<ResetPassword />}></Route>

        {/* Helper pages */}
        <Route path={`${process.env.PUBLIC_URL}/auths/terms`} element={<Terms />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/auths/faq`} element={<Faq />}></Route>

        {/*Error Pages*/}
        <Route path={`${process.env.PUBLIC_URL}/errors/404-classic`} element={<Error404Classic />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/errors/504-modern`} element={<Error504Modern />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/errors/404-modern`} element={<Error404Modern />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/errors/504-classic`} element={<Error504Classic />}></Route>

        {/*Main Routes*/}
        <Route path="*" element={<PrivateRoute component={Layout} />}></Route>
        <Route path="*" element={<RedirectAs404 />}></Route>
      </Routes>
    ) : (
      <></>
    )}
      <LoadingComponent isLoading={loading} isFade={false} />
    </>
  );
};
export default App;
